import axios from 'axios'
import apiRoutes from '@/router/api-routes'

const http = axios.create({
    baseURL: apiRoutes.baseURL,
    withCredentials: true
})

http.defaults.withCredentials = true

http.interceptors.request.use(function(request) {
    if (!request.baseURL.indexOf(apiRoutes.baseURL)) {
        // console.log('to our api')
    } else {
        // console.log('other api')
    }
    return request
}, function(error) {
    return Promise.reject(error)
})

http.interceptors.response.use(function(response) {
    return response
}, function(error) {
    return Promise.reject(error.response || { response: { status: error.statusCode, message: error.message } })
})

export default http